import React from 'react'
import classNames from 'classnames'

import { ErrorModuleProps } from './ErrorModule.schema'

import Appear from '@/appear/Appear'
import Container from '@/container/Container'
import TitleText from '@/title-text/TitleText'
import Logo from '@/logo/Logo'
import Image from '@/image/Image'

const ErrorModule = (props: ErrorModuleProps): JSX.Element => {
    const className = classNames('error-module', props.className, `error-module--${props?.options?.backgroundColor || 'purple'}`, { 'has-header': props.hasHeader })

    return (
        <div className={className}>
            <Container className='error-module__container'>
                <div className='error-module__inner'>
                    <div className='error-module__column error-module__content-column'>
                        <Appear cascade>
                            {props.showLogo && <Logo isInverted {...props.logo} />}
                            <TitleText
                                title={props.title}
                                text={props.description}
                                button={props.button}
                                hasMarkdown
                                disableAppear
                                hasTitleAnimation={false}
                            />
                            {props.errorMessage && <p className='error-module__error'>{props.errorMessage}</p>}
                            {props.errorDescription && <p className='error-module__error'>{props.errorDescription}</p>}
                        </Appear>
                    </div>
                    <div className='error-module__column error-module__image-column'>
                        {props?.image?.url && (
                            <Appear>
                                <Image
                                    className='error-module__image'
                                    width={1031}
                                    height={774}
                                    sizes='(max-width: 1024px) 100vw, (max-width: 1920px) 50vw, 1031px'
                                    priority={true}
                                    loading='eager'
                                    url={props.image.url}
                                    alternativeText={props.image.alternativeText}
                                />
                            </Appear>
                        )}
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default ErrorModule
